import toastr from 'toastr';
import { ReactNode } from 'react';
import {
  getAcademicsPageDetails,
  getAuthPageDetails,
  getCommunicationPageDetails,
  getDashBoardPageDetails,
  getFinancePageDetails,
  getAdministrationPageDetails,
  getPrivacyPageDetails,
  getProfilePageDetails,
  getStaffPageDetails,
  getStudentsPageDetails,
  getSettingsPageDetails,
  getAnalyticsPageDetails,
  getUsersPageDetails,
  getLogoutPageDetails,
  getGuardianPageDetails,
} from './pages-helpers';
// import "./toastr.min.css";

const options = (timer = 5000) => {
  return {
    timeout: timer,
    showEasing: 'swing',
    hideEasing: 'linear',
    positionClass: 'toast-bottom-center',
  };
};

// custom logger for prod mode handling
export const logger = {
  log: (...arg: any) => {
    console.log(...arg);
  },
  warn: (...arg: any) => {
    console.warn(...arg);
  },
  info: (...arg: any) => {
    console.info(...arg);
  },
  error: (...arg: any) => {
    console.error(...arg);
  },
  show_success: (msg: string, title = '', timer = 5000) => {
    toastr.remove(); // hides without animation, instantly
    toastr.success(msg, title, options(timer));
  },
  show_warn: (msg: string, title = '', timer = 5000) => {
    toastr.remove(); // hides without animation, instantly
    toastr.warning(msg, title, options(timer));
  },
  show_info: (msg: string, title = '', timer = 5000) => {
    toastr.remove(); // hides without animation, instantly
    toastr.info(msg, title, options(timer));
  },
  show_error: (msg: string, title = '', timer = 50000) => {
    toastr.remove(); // hides without animation, instantly
    toastr.error(msg, title, options(timer));
  },
  hide_toastr: () => {
    toastr.clear(); // hides with animation
  },
  remove_toastr: () => {
    toastr.remove(); // hides without animation, instantly
  },
};

export type PageItem = {
  [key: string]: {
    path: string;
    aliasPath?: string;
    title: string;
    icon?: ReactNode;
    subPages?: PageItem;
  };
};

export const pages: PageItem = {
  ...getAuthPageDetails(),
  ...getDashBoardPageDetails(),
  ...getStudentsPageDetails(),
  ...getStaffPageDetails(),
  ...getAcademicsPageDetails(),
  ...getCommunicationPageDetails(),
  ...getFinancePageDetails(),
  ...getAnalyticsPageDetails(),
  ...getAdministrationPageDetails(),
  ...getUsersPageDetails(),
  ...getSettingsPageDetails(),
  ...getPrivacyPageDetails(),
  ...getProfilePageDetails(),
  ...getLogoutPageDetails(),
  ...getGuardianPageDetails(),
};

export const getOS = () => {
  const userAgent = window.navigator.userAgent;
  const platform = window.navigator.platform;
  const macosPlatforms = ['Macintosh', 'MacIntel', 'MacPPC', 'Mac68K'];
  const windowsPlatforms = ['Win32', 'Win64', 'Windows', 'WinCE'];
  const iosPlatforms = ['iPhone', 'iPad', 'iPod'];
  let os = null;

  if (macosPlatforms.indexOf(platform) !== -1) {
    os = 'Mac OS';
  } else if (iosPlatforms.indexOf(platform) !== -1) {
    os = 'iOS';
  } else if (windowsPlatforms.indexOf(platform) !== -1) {
    os = 'Windows';
  } else if (/Android/.test(userAgent)) {
    os = 'Android';
  } else if (!os && /Linux/.test(platform)) {
    os = 'Linux';
  }

  return os;
};

export const getAllowedFileTypesForDocumentUpload = () => {
  return [
    'application/pdf',
    'image/*',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/vnd.ms-powerpoint',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation',
  ];
};
